export default {
    primaryColor: "#4F9DDE",
    green:"#34D859",
    gray: "rgba(24,28,28,0.2)",
    red: "#F34848",
    red2: "rgba(236,90,81,0.8)",
    darkPurple:"#292F4c",
    gray2: "rgba(241,237,237,0.3)",
    gray3: "rgba(24, 28, 47, 0.3)",   
    gray4: "#EFECE8",
    gray5: "#D8D8D8",
    grediantGary:"linear-gradient(119.19deg, #FFFFFF 0%, #F8F8F8 65.34%, #FFFFFF 100%)",

    grayDark: "#181C2F",
    grayDark2: "rgba(33,33,33,33,0.58)",

    background:"white",
    inactiveColor:"rgba(41,47,76,0.3)",
    inactiveColorDark:"white",

    xxsmall:"0.8rem",
    xsamll:"1rem",
    small:"1.2rem",
    normal: "1.4rem",
    medium: "1.6rem",
    large:"1.8rem",
    xlarge:"2rem",
    xxlarge:"2.4rem",
    

};